import { render, staticRenderFns } from "./InfoAssess.vue?vue&type=template&id=536f101c&scoped=true&"
import script from "./InfoAssess.vue?vue&type=script&lang=js&"
export * from "./InfoAssess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f101c",
  null
  
)

export default component.exports